import { render, staticRenderFns } from "./OR.vue?vue&type=template&id=756a38ba&scoped=true"
import script from "./OR.vue?vue&type=script&lang=js"
export * from "./OR.vue?vue&type=script&lang=js"
import style0 from "./OR.vue?vue&type=style&index=0&id=756a38ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a38ba",
  null
  
)

export default component.exports